export {
  HandwrittenExpressionRecogniserDNN
  as HandwrittenExpressionRecogniser
} from './dnn/handwritten-expression-recogniser-dnn';
export { HandwrittenExpressionRecogniserDNN } from './dnn/handwritten-expression-recogniser-dnn';
export { HandwrittenExpressionRecogniserCNN } from './cnn/handwritten-expression-recogniser-cnn';
